import {AddressInitState, Amphures, Districts, Provinces} from '@/store/address/address.types';
import {AddressAction} from '@/store/address/address.actions';
import {AddressMutations} from '@/store/address/address.mutations';

const namespaced = true;

export const addressInitState: AddressInitState = {
  provinces: [{}] as Provinces[],
  amphures: [{}] as Amphures[],
  districts: [{}] as Districts[],
};

export const addressState = {
  namespaced,
  state: addressInitState,
  actions: AddressAction,
  mutations: AddressMutations,
  // getters
};
